import { httpDelete, httpGet, httpPost, httpPut } from "./http";
import { rppAuthScope} from "./authenticationUtils.ts";

export const apiGet = async <T>(url: string): Promise<T> => {
    return httpGet(getFullUrl(url), [rppAuthScope]);
}

export const apiPost = async <T, Model>(url: string, model: Model): Promise<T> => {
    return httpPost(getFullUrl(url), model, [rppAuthScope]);
}

export const apiPut = async <T, Model>(url: string, model: Model): Promise<T> => {
    return httpPut(getFullUrl(url), model, [rppAuthScope]);
}

export const apiDelete = async <T>(url: string): Promise<T> => {
    return httpDelete(getFullUrl(url), [rppAuthScope]);
}

export const getFullUrl = (url: string): string => {
    return `${globalThis.config.api_url}/${url}`;
};
